import React, { useState } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import { Form, Col, Row } from 'react-bootstrap';
import { isEmpty, includes, map } from 'lodash';

import { LAYER_SUBTYPES } from '../../../api/Layers/Layers';
import * as layerOps from '../../../api/Layers/layer-operations';

const LayerExcelFields = ({
  excelColumns,
  excelSheet,
  excelTableLength,
  excelTableWidth,
  layer,
  layerSubType,
  sheetList,
  loadExcelColumnsAndRows,
  loadExcelTableTitles
}) => {
  const [firstRow, changeFirstRow] = useState(layerOps.getFirstRow(layer));
  const [lastRow, changeLastRow] = useState(layerOps.getLastRow(layer));
  const [firstColumn, changeFirstColumn] = useState(layerOps.getFirstColumn(layer));
  const [lastColumn, changeLastColumn] = useState(layerOps.getLastColumn(layer));
  const maxRowValue = excelTableLength === 1 ? layerOps.getLastRow(layer) : excelTableLength;
  const maxColumnValue = excelTableWidth === 1 ? layerOps.getLastColumn(layer) : excelTableWidth;

  if (
    !includes([LAYER_SUBTYPES.EXCEL, LAYER_SUBTYPES.GOOGLE_SHEETS], layerSubType) ||
    (isEmpty(sheetList) &&
      !includes([LAYER_SUBTYPES.EXCEL, LAYER_SUBTYPES.GOOGLE_SHEETS], layerOps.getSubType(layer)))
  )
    return '';

  return (
    <>
      {!isEmpty(sheetList) && (
        <Form.Group>
          <Form.Label>Sheet Name</Form.Label>
          <Form.Control
            as="select"
            name="excelSheet"
            value={excelSheet}
            onChange={loadExcelColumnsAndRows}
          >
            <option key="" value="">
              -
            </option>
            {map(sheetList, sheetName => {
              return (
                <option value={sheetName} key={uuid()}>
                  {sheetName}
                </option>
              );
            })}
          </Form.Control>
        </Form.Group>
      )}
      {!isEmpty(excelSheet) && (
        <Form.Group as={Row}>
          <Form.Label column xs={3}>
            First Row
          </Form.Label>
          <Col xs={3}>
            <Form.Control
              type="number"
              name="excelFirstRow"
              value={firstRow}
              min="1"
              max={lastRow}
              onChange={event => {
                changeFirstRow(Number(event.target.value));
                loadExcelTableTitles(event);
              }}
            />
          </Col>
          <Form.Label column xs={3}>
            Last Row
          </Form.Label>
          <Col xs={3}>
            <Form.Control
              type="number"
              name="excelLastRow"
              value={lastRow}
              min={firstRow}
              max={maxRowValue}
              onChange={event => {
                changeLastRow(Number(event.target.value));
                loadExcelTableTitles(event);
              }}
            />
          </Col>
        </Form.Group>
      )}
      {!isEmpty(excelSheet) && layerSubType === LAYER_SUBTYPES.EXCEL && (
        <Form.Group as={Row}>
          <Form.Label column xs={3}>
            First Column
          </Form.Label>
          <Col xs={3}>
            <Form.Control
              type="number"
              name="excelFirstColumn"
              value={firstColumn}
              min="1"
              max={lastColumn}
              onChange={event => {
                changeFirstColumn(Number(event.target.value));
                loadExcelTableTitles(event);
              }}
            />
          </Col>
          <Form.Label column xs={3}>
            Last Column
          </Form.Label>
          <Col xs={3}>
            <Form.Control
              type="number"
              name="excelLastColumn"
              value={lastColumn}
              min={firstColumn}
              max={maxColumnValue}
              onChange={event => {
                changeLastColumn(Number(event.target.value));
                loadExcelTableTitles(event);
              }}
            />
          </Col>
        </Form.Group>
      )}
      {!isEmpty(excelSheet) && layerSubType === LAYER_SUBTYPES.GOOGLE_SHEETS && (
        <Form.Group>
          <Form.Label>Columns to show</Form.Label>
          <Form.Control
            as="select"
            multiple
            name="excelColumns"
            defaultValue={excelColumns}
            onChange={loadExcelTableTitles}
          >
            {map(excelColumns, option => (
              <option value={option} key={option}>
                {option}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      )}
    </>
  );
};

LayerExcelFields.propTypes = {
  excelSheet: PropTypes.string.isRequired,
  excelColumns: PropTypes.array.isRequired,
  excelTableLength: PropTypes.number.isRequired,
  excelTableWidth: PropTypes.number.isRequired,
  layer: PropTypes.object.isRequired,
  layerSubType: PropTypes.string.isRequired,
  sheetList: PropTypes.array.isRequired,
  loadExcelColumnsAndRows: PropTypes.func.isRequired,
  loadExcelTableTitles: PropTypes.func.isRequired
};

export default LayerExcelFields;
